module.exports = __webpack_public_path__ + "static/media/9.813a8748.png";